import { Middleware, MiddlewareAPI } from "redux";
import { Action } from "typescript-fsa";

import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";
import { Commands, Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import {
	FormEngineActions,
	FormEngineSelectors
} from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { findElementByFormModelPath, FormModel } from "@com.mgmtp.a12.formengine/formengine-core/lib/models";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { ModulfDataSelectors } from "../../../utilities/selectors/modulfDataSelectors";
import { ModulfUiSelectors } from "../../../utilities/selectors/modulfUiSelectors";

/**
 * Stellt sicher, dass im correctionMode innerhalb des detailsScreen eines detachedRepeat ein backup gesetzt wird,
 * da ansonsten der abbruch im detailsScreen zu einem Fehler aufgrund des fehlenden Backups fuehrt.
 */
export const detailsScreenValidationMiddleware: Middleware<unknown, { locale: Locale }> = api => next => action => {
	const result = next(action);
	if (FormEngineActions.event.match(action) && Events.CorrectionMode.goToElement.match(action.payload.engineEvent)) {
		pushBackup(action.payload.engineEvent, action.payload.activityId, api);
	}

	return result;
};

function pushBackup(action: Action<Events.CorrectionMode.GoToElementPayload>, activityId: string, api: MiddlewareAPI) {
	const { formModelPath } = action.payload.item;
	const formModel = FormEngineSelectors.models(activityId)(api.getState())?.formModel;
	if (!formModel) {
		return;
	}

	const subPaths = getEverySubPath(formModelPath);
	const containsDetachedRepeat = subPaths
		.map(e => findElementByFormModelPath(formModel, e))
		.filter(e => e)
		.some(e => FormModel.DetachedRepeat.isInstance(e));
	if (!containsDetachedRepeat) {
		return;
	}

	const document = ModulfDataSelectors.selectTaskDocument(activityId)(api.getState());
	const messages = ModulfUiSelectors.selectValidationMessages(activityId)(api.getState());
	if (!document) {
		return;
	}

	api.dispatch(
		FormEngineActions.command({
			activityId,
			engineEvent: Commands.pushBackup({
				document,
				messages
			})
		})
	);
}

function getEverySubPath(formModelPath: ModelPath): ModelPath[] {
	const subPathsArray = [] as ModelPath[];
	for (let i = 0; i < formModelPath.length; i++) {
		subPathsArray.push(formModelPath.slice(0, -i));
	}
	return subPathsArray;
}
